module.exports = __webpack_public_path__ + "text.9ded0a26.png";